import { makeStyles } from '@material-ui/core/styles';

export const styles = (theme) => ({
  width: '100%',
  maxWidth: theme.breakpoints.values.lg,
  margin: 'auto',
  padding: theme.spacing(4, 2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(6.25),
  },
});

export const useContainerStyles = makeStyles((theme) => ({
  root: styles(theme),
}));
